import {QuestionnaireStep} from '@letrustech/letrus-api-interfaces/dist/interfaces/letrus_api';
import TextChipsList from 'components/SatisfactionRatingForm/TextChipsList';
import {SubmitParams} from 'containers/SatisfactionRating';
import {NewButton} from 'components/ui';
import React, {useState} from 'react';
import EmojiRating from './EmojiRating/index';
import styles from './SatisfactionRatingForm.module.scss';

export interface SatisfactionRatingFormProps {
  onSubmit({comment, rating, satisfactionReasons}: SubmitParams): void;
  onExit: () => void;
  lowerRatingChoices: QuestionnaireStep;
  higherRatingChoices: QuestionnaireStep;
}

const SatisfactionRatingForm: React.FC<SatisfactionRatingFormProps> = ({
  onSubmit,
  onExit,
  lowerRatingChoices,
  higherRatingChoices,
}) => {
  const [enableSubmit, setEnableSubmit] = useState(false);
  const [currentRatingChoices, setCurrentRatingChoices] =
    useState<QuestionnaireStep>();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const rating = String(formData.get('emojiRating'));
    const comment = String(formData.get('comment'));
    const reasons = formData.getAll('reasons').map((reason) => Number(reason));
    onSubmit({
      comment,
      rating,
      satisfactionReasons: {
        questionId: String(currentRatingChoices?.question.id),
        choices: reasons,
      },
    });
  };

  const handleSelectedRating = (selectedRating: string) => {
    if (selectedRating && !enableSubmit) {
      setEnableSubmit(!enableSubmit);
    }
    if (Number(selectedRating) < 5) {
      setCurrentRatingChoices(lowerRatingChoices);
      return;
    }
    setCurrentRatingChoices(higherRatingChoices);
  };

  return (
    <form className={styles.wrapper} onSubmit={(e) => handleSubmit(e)}>
      <h1 className={styles.title}>Nos diga o que achou dessa atividade!</h1>
      <p className={styles.description}>
        Nós valorizamos muito sua opinião e, por isso, gostaríamos de saber o
        que você achou dessa jornada. Avalie abaixo como foi sua experiência e,
        se quiser, deixe um comentário!
      </p>
      <EmojiRating name="emojiRating" selectedRating={handleSelectedRating} />
      {enableSubmit && (
        <>
          <h2 className={styles.secondaryTitle}>
            Selecione um ou mais motivos abaixo:
          </h2>
          <TextChipsList name="reasons" question={currentRatingChoices} />
          <textarea
            className={styles.textArea}
            placeholder="Digite aqui seu comentário"
            name="comment"
          />
        </>
      )}
      <p className={styles.note}>
        *Esta etapa é opcional! Se não quiser responder, clique no botão
        &quot;Sair&quot;.
      </p>
      <div className={styles.controls}>
        <NewButton userRole="student" kind="secondary" onClick={onExit}>
          Sair
        </NewButton>
        <NewButton userRole="student" type="submit" disabled={!enableSubmit}>
          Enviar
        </NewButton>
      </div>
    </form>
  );
};

export default SatisfactionRatingForm;
